import React, { FC, useCallback } from "react";
import { IDamsList, IStateOfKnowledge, dataEntry, IDataTest, ISocietalRisk, ISummaryControlMeasureAdequacy, ISummaryControlMeasureAssessment, ICostSummary, ISummaryCriticalHazards, ISummarySOK, ILikelihood, IHarmSummary } from "../../types/types";
import { Accordion, AccordionSummary, Grid, Paper, Tooltip, IconButton, colors } from "@material-ui/core";
import BarChart from "./bar";
import DamHeatMap from "./dam_heat_map";
import { ExpandMore } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import Map from "./map";
import PieChart from "./pie";
import { trafficLight } from "../../theme";
import SoKInfo from "./sok_infobar";
import NoDamInfo from "./no_dam";
import HeatMapTable from "./heat_map_table";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { CSVLink, CSVDownload } from "react-csv";
import SummaryLegend from "./summay_ledgend";


import GetAppIcon from '@material-ui/icons/GetApp';
import NotesIcon from '@material-ui/icons/Notes';


import { toPng } from "html-to-image";
import downloadjs from "downloadjs";

interface ISokProps {
    countData: any[]
}


const SummaryPie: FC<ISokProps> = ({ countData }) => {

    // console.log(countData)

    // count the number of control measures in each catergory

    let rp = 0
    let rpt = 0
    let npt = 0
    let np = 0
    let dm = 0
    let undefined = 0

    countData.forEach((dam: number[]) => {
        rp += dam[0]
        rpt += dam[1]
        npt += dam[2]
        np += dam[3]
        dm += dam[4]
        undefined += dam[5]

    })

    // console.log([rp, rpt, npt, np, dm, undefined])


    const pie_input = {
        title: `Reasonably Practicable assessment of controls`,
        description: ["Individual Risk Confidence", "Societal Confidence"],
        data: [ { name: 'De Minimus', value: [dm] },
        { name: 'RP', value: [rp] },
        { name: 'RP (Tentative)', value: [rpt] },
        { name: 'NRP (Tentative)', value: [npt] },
        { name: 'NRP', value: [np] },
        { name: 'Cannot Determine', value: [undefined] },
       ],
        colour: {
            background: [trafficLight.cmred, trafficLight.cmorange, trafficLight.cmyellow, trafficLight.bgreen, trafficLight.cmgreen, trafficLight.grey],
            font: [trafficLight.cmred,trafficLight.cmdorange, trafficLight.yellow, trafficLight.green, trafficLight.green,trafficLight.grey]
        },
        height: 375

    }

    return (
        <PieChart data={pie_input}/>
    )
}


export default SummaryPie